import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class BaoCaoLichsuLoiService {

  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle";

  public baocao_lichsuloi(danhmucid, tungay, denngay, meterid, loailoi, sotrang, sodong) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGKE_CHATLUONG_HT.P_BAOCAO_LICHSU_LOI" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_meterid: meterid,
        v_loailoi: loailoi,
        v_sotrang: sotrang,
        v_sodong: sodong
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  getDSLoaiLoi() {
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAYDS_LOAILOI"}',
      "para": ''
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-lich-su-loi/bao-cao-lichsu-loi.service.ts